import React, { useEffect, useState } from "react";
import { DocRenderer, textFileLoader } from "@cyntler/react-doc-viewer";
import { ColumnsType } from "antd/lib/table";
import { ZTooltip } from "@atoms";
import { parse } from "@/Utils";
import ZTable from "../ZTable";
import "./index.less";

const ZCSVRenderer: DocRenderer = ({ mainState: { currentDocument } }) => {
	const [rows, setRows] = useState<Record<string, string>[]>([]);
	const [columns, setColumns] = useState<ColumnsType>([]);

	const generateColumns = (record: string[]): ColumnsType =>
		record.map((col, index) => ({
			dataIndex: `key-${index}`,
			title: () => (
				<ZTooltip placement="topLeft" title={col}>
					{col}
				</ZTooltip>
			),
			ellipsis: { showTitle: true },
			render: address => (
				<ZTooltip placement="topLeft" title={address}>
					{address}
				</ZTooltip>
			)
		}));

	const handleParse = () => {
		if (!currentDocument?.fileData) return;
		const record = parse(currentDocument.fileData as string, {});
		const rows: Record<string, string>[] = [];
		for (let i = 1; i < record.length; i++) {
			const row: Record<string, string> = {};
			record[i].forEach((cell, idx) => {
				row[`key-${idx}`] = cell;
			});
			rows.push(row);
		}
		setColumns(generateColumns(record[0]));
		setRows(rows);
	};

	useEffect(() => {
		if (currentDocument?.fileData) {
			handleParse();
		}
	}, [currentDocument]);

	if (!rows.length) {
		return null;
	}
	return (
		<ZTable
			size="small"
			loading={false}
			columns={columns as any}
			dataSource={rows}
			pagination={{
				pageSize: 25
			}}
			scroll={{ y: 410, x: true }}
			className="z-csv-renderer-table"
		/>
	);
};

export default ZCSVRenderer;

ZCSVRenderer.fileTypes = ["csv", "text/csv"];
ZCSVRenderer.weight = 0;
ZCSVRenderer.fileLoader = textFileLoader;
